'use client';

import Image from "next/image";
import Link from "next/link";

export function ErrorSection() {
  return (
    <div className="min-h-[400px] flex items-center justify-center px-4 py-8">
      <div className="max-w-md w-full text-center">
        <div className="mb-8 flex justify-center">
          <Image
            src="/no-result.svg"
            alt="Halaman Tidak Tersedia"
            width={300}
            height={300}
          />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Halaman Tidak Tersedia
        </h1>
        
        <p className="text-gray-600 mb-8 leading-relaxed">
          Halaman ini tidak dapat diakses atau sudah tidak tersedia. 
          Silakan periksa kembali alamat yang Anda masukkan atau gunakan menu navigasi 
          untuk menemukan informasi yang Anda perlukan.
        </p>
        
        <Link
          href="/"
          className="inline-block bg-primary-600 bg-primary-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
        >
          Kembali ke Beranda
        </Link>
      </div>
    </div>
  );
}
